import PermissionsTable from "@/components/PermissionsTable/PermissionsTable";
import { ResturantData } from "@/types/globalTypes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, Outlet, useMatch, useNavigate } from "react-router-dom";

function Permissions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Match relative child routes
  const isPermissions = useMatch("/settings/permissions");

  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );

  const WithoutPlan = ResturantData?.subscription === null;

  useEffect(() => {
    if (WithoutPlan) {
      navigate("/notfound");
    } else {
      return;
    }
  }, [WithoutPlan, navigate]);

  return (
    <>
      {isPermissions && (
        <>
          <Link
            to="add-employee"
            className="mt-5 flex w-fit items-center gap-2 rounded-full bg-skyblue px-4 py-2 text-sidebar"
          >
            {t("permissions.add")} +
          </Link>
          <PermissionsTable />
        </>
      )}
      <Outlet />
    </>
  );
}

export default Permissions;
